export default "__VITE_ASSET__CD5W6X_S__"